import { useTranslation } from '@shared/localization';
import { useMemo } from 'react';

import { PageLayout, PrimaryButton } from '@/components/common';
import { AlertError } from '@/components/common/alerts';

interface ISomethingWentWrongProps {
  readonly err?: Error;
  readonly description?: string;
  readonly orderId?: string;
}

export function SomethingWentWrong({
  err,
  description,
  orderId,
}: ISomethingWentWrongProps) {
  const { t } = useTranslation();

  const errorNameToUserFriendlyTitle = useMemo(() => {
    if (!err) return t('Something went wrong!');
    switch (err.name) {
      case 'IntentAlreadyProcessedError':
        return t('Payment Already Proccessed');
      case 'CannotFetchIntentError':
        return t('Cannot Find Payment Intent');
      case 'AuthorizationError':
        return t('Not Authorized');
      default:
        return err.name;
    }
  }, [err, t]);

  const alertDescription = err ? err.message : description;

  const shouldShowGoBackButton =
    err &&
    ['IntentAlreadyProcessedError', 'CannotFetchIntentError'].includes(
      err.name,
    ) &&
    document.referrer;

  return (
    <PageLayout
      headerDescription={
        orderId ? `${t('Order: {{orderNumber}}')}: ${orderId}` : undefined
      }
    >
      <AlertError
        title={errorNameToUserFriendlyTitle}
        description={alertDescription}
      />
      {shouldShowGoBackButton && (
        <div className="w-full flex flex-row">
          <PrimaryButton
            className="mx-sm md:mx-md"
            onClick={() => (window.location.href = document.referrer)}
          >
            {t('Go back and restart')}
          </PrimaryButton>
        </div>
      )}
    </PageLayout>
  );
}
